<template>
  <l-modal :showing="showing" text="Processes" icon="edit" color="bg-orange-500" @close="close">
    <div class="w-full text-xs" v-if="editObj.id">
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Id</b>
          <br />
          <l-input
            placeholder="Enter unique Id"
            v-model="editObj.id"
            inputClass="text-2xs"
            :disabled="!this.isnew"
          ></l-input>
        </div>
        <div class="w-1/2">
          <b>Measurement Type</b>
          <br />
          <l-select
            v-model="editObj.measurement_type"
            class="text-xs"
            :data="measurementtypes"
            :multiple="false"
          >
            <l-option
              v-for="i in measurementtypes"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Measurement Method</b>
          <br />
          <l-select
            v-model="editObj.measurement_method"
            class="text-xs"
            :data="measurementmethods"
            :multiple="false"
          >
            <l-option
              v-for="i in measurementmethods"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
        <div class="w-1/2">
          <b>Other Measurement Method</b>
          <br />
          <l-input
            placeholder="Enter 'Other Measurement Method' (optional) (text)"
            v-model="editObj.other_measurement_method"
            inputClass="text-2xs"
          ></l-input>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Analytical Tech</b>
          <br />
          <l-input
            placeholder="Enter 'Analytical Tech' (optional) (text)"
            v-model="editObj.analytical_tech"
            inputClass="text-2xs"
          ></l-input>
        </div>
        <div class="w-1/2">
          <b>Other Analytical Tech</b>
          <br />
          <l-input
            placeholder="Enter 'Other Analytical Tech' (optional) (text)"
            v-model="editObj.other_analytical_tech"
            inputClass="text-2xs"
          ></l-input>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Sampling Equipment</b>
          <br />
          <l-input
            placeholder="Enter 'Sampling Equipment' (optional) (text)"
            v-model="editObj.sampling_equipment"
            inputClass="text-2xs"
          ></l-input>
        </div>
        <div class="w-1/2">
          <b>Measurement Equipment</b>
          <br />
          <l-select
            v-model="editObj.measurement_equipment"
            class="text-xs"
            :data="measurementequipments"
            :multiple="false"
          >
            <l-option
              v-for="i in measurementequipments"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Equiv Demonstration</b>
          <br />
          <l-select
            v-model="editObj.equiv_demonstration"
            class="text-xs"
            :data="equivalencedemonstrated"
            :multiple="false"
          >
            <l-option
              v-for="i in equivalencedemonstrated"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
        <div class="w-1/2">
          <b>Equiv Demonstration Report</b>
          <br />
          <l-input
            placeholder="Enter 'Equiv Demonstration Report' (optional) (text)"
            v-model="editObj.equiv_demonstration_report"
            inputClass="text-2xs"
          ></l-input>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Detection Limit</b>
          <br />
          <l-input
            placeholder="Enter 'Detection Limit' (optional) (decimal number)"
            v-model="editObj.detection_limit"
            inputClass="text-2xs"
          ></l-input>
        </div>
        <div class="w-1/2">
          <b>Detection Limit Uom</b>
          <br />
          <l-select
            v-model="editObj.detection_limit_uom"
            class="text-xs"
            :data="concentrations"
            :multiple="false"
          >
            <l-option
              v-for="i in concentrations"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Uncertainty Estimate</b>
          <br />
          <l-input
            placeholder="Enter 'Uncertainty Estimate' (optional) (decimal number)"
            v-model="editObj.uncertainty_estimate"
            inputClass="text-2xs"
          ></l-input>
        </div>
        <div class="w-1/2">
          <b>Documentation</b>
          <br />
          <l-input
            placeholder="Enter 'Documentation' (optional) (text)"
            v-model="editObj.documentation"
            inputClass="text-2xs"
          ></l-input>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>QA Report</b>
          <br />
          <l-input
            placeholder="Enter 'QA Report' (optional) (text)"
            v-model="editObj.qa_report"
            inputClass="text-2xs"
          ></l-input>
        </div>
        <div class="w-1/2">
          <b>Duration Number</b>
          <br />
          <l-input
            placeholder="Enter 'Duration Number' (whole number)"
            v-model="editObj.duration_number"
            inputClass="text-2xs"
          ></l-input>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Duration Unit</b>
          <br />
          <l-select v-model="editObj.duration_unit" class="text-xs" :data="times" :multiple="false">
            <l-option
              v-for="i in times"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
        <div class="w-1/2">
          <b>Cadence Number</b>
          <br />
          <l-input
            placeholder="Enter 'Cadence Number' (whole number)"
            v-model="editObj.cadence_number"
            inputClass="text-2xs"
          ></l-input>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Cadence Unit</b>
          <br />
          <l-select v-model="editObj.cadence_unit" class="text-xs" :data="times" :multiple="false">
            <l-option
              v-for="i in times"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
        <div class="w-1/2">
          <b>Responsible Authority ID</b>
          <br />
          <l-select
            v-model="editObj.responsible_authority_id"
            class="text-xs"
            :data="responsibleauthorities"
            :multiple="false"
          >
            <l-option
              v-for="i in responsibleauthorities"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Other Measurement Equipment</b>
          <br />
          <l-input
            placeholder="Enter 'Other Measurement Equipment' (optional) (text)"
            v-model="editObj.other_measurement_equipment"
            inputClass="text-2xs"
          ></l-input>
        </div>
        <div class="w-1/2">
          <b>Other Sampling Equipment</b>
          <br />
          <l-input
            placeholder="Enter 'Other Sampling Equipment' (optional) (text)"
            v-model="editObj.other_sampling_equipment"
            inputClass="text-2xs"
          ></l-input>
        </div>
      </div>
      <div class="flex w-full justify-between">
        <l-button type="success" @click="onSave">Save changes</l-button>
        <l-button type="danger" @click="close">Cancel</l-button>
      </div>
    </div>
  </l-modal>
</template>

<script>
import LModal from "@/components/LModal";
import { LInput, LButton, LSelect, LOption } from "@/components/forms";

export default {
  name: "LLEdit",
  props: [
    "showing",
    "processes",
    "measurementtypes",
    "measurementmethods",
    "measurementequipments",
    "equivalencedemonstrated",
    "concentrations",
    "times",
    "responsibleauthorities",
    "selected",
    "isnew"
  ],
  components: {
    LModal,
    LInput,
    LButton,
    LSelect,
    LOption
  },
  computed: {
    editObj: function() {
      return Object.assign({}, this.selected);
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSave() {
      const mt = this.measurementtypes.find(
        r => r.value == this.editObj.measurement_type
      );
      this.editObj.measurement_type_name = mt.label;

      const mm = this.measurementmethods.find(
        r => r.value == this.editObj.measurement_method
      );
      this.editObj.measurement_method_name = mm.label;

      const me = this.measurementequipments.find(
        r => r.value == this.editObj.measurement_equipment
      );
      this.editObj.measurement_equipment_name = me.label;

      const ed = this.equivalencedemonstrated.find(
        r => r.value == this.editObj.equiv_demonstration
      );
      this.editObj.equiv_demonstration_name = ed.label;

      const c = this.concentrations.find(
        r => r.value == this.editObj.detection_limit_uom
      );
      this.editObj.concentration_name = c.label;

      const du = this.times.find(r => r.value == this.editObj.duration_unit);
      this.editObj.duration_unit_name = du.label;

      const cu = this.times.find(r => r.value == this.editObj.cadence_unit);
      this.editObj.cadence_unit_name = cu.label;

      const ra = this.responsibleauthorities.find(
        r => r.value == this.editObj.responsible_authority_id
      );
      this.editObj.responsible_authority_name = ra.label;

      this.$emit("save", this.editObj);
      this.close();
    }
  }
};
</script>